export const APP_NAME = 'Zaman Al Ahd Air Conditioning Trading FZE'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'redirectUrl'